module.exports = __webpack_public_path__ + "aec262a7.svg";